import React from 'react';
import PropTypes from 'prop-types';
import * as styled from './styles';
import get from 'lodash/get';
import { Swirl } from '../../vector';

function DecoratedBubbleBlock(props) {
  const {
    colorTheme,
    decoratedSwirle,
    items,
  } = props;

  return (
    <styled.Wrapper colorTheme={colorTheme}>
      <styled.Inner colorTheme={colorTheme}>
        <styled.Content>
          <styled.Items>
            {items.map((item) => {
              const linkTo = `${item.route ? get(item, 'route.slug.current') : item.link}${item.linkAnchor || ''}`;

              return (
                <styled.Item colorTheme={item.colorTheme} transparent={item.isTransparent}>
                  {item.image ? (
                    <styled.ItemImage>
                      <styled.Image
                        edge={0}
                        altText={item.image.altText}
                        fluid={get(item, 'image.asset.fluid')}
                        loading="eager"
                      />
                    </styled.ItemImage>
                  ) : null}
                  <styled.ItemData>
                    <styled.Title level={400}>{item.title}</styled.Title>
                    {item.label && linkTo ?
                      <styled.Link level={500} to={linkTo} key={item.title || linkTo}>{item.label}</styled.Link> : null}
                  </styled.ItemData>
                </styled.Item>
              );
            })}
          </styled.Items>
        </styled.Content>
        {decoratedSwirle ? <Swirl /> : null}
      </styled.Inner>
    </styled.Wrapper>
  );
}

DecoratedBubbleBlock.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.object,
    link: PropTypes.string,
    linkAnchor: PropTypes.string,
    route: PropTypes.shape({
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
    }),
  })),
  decoratedSwirle: PropTypes.bool,
  colorTheme: PropTypes.oneOf(['dark-blue', 'green', 'orange', 'dark-purple', 'white']),
};

DecoratedBubbleBlock.defaultProps = {
  colorTheme: 'dark-blue',
  decoratedSwirle: false,
};

export default DecoratedBubbleBlock;
